export const isLoggedIn = (setLogin) => {
  const isLoggedIn = localStorage.getItem("user") ? true : false;
  setLogin(isLoggedIn);
  return isLoggedIn;
};
